import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SizeForm from "./SizeForm";
import { getEditSize, getSizeById } from "../../../api/sizeService";
import { getErrorMessage } from "../../../utils/errorHandler";

export default function EditSize() {
  const location = useLocation();
  const id = location?.state?.sizeId;
  const navigate = useNavigate();
  const [size, setSize] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [backendErrors, setBackendErrors] = useState({});

  useEffect(() => {
    fetchSize();
  }, []);

  const fetchSize = async () => {
    try {
      const response = await getSizeById(id);
      setSize(response?.data || response);
    } catch (error) {
      console.error(error);
      alert(getErrorMessage(error));
    } finally {
      setPageLoading(false);
    }
  };

  const handleSubmit = async (formData) => {
    try {
      setLoading(true);
      const response = await getEditSize(id, formData);
      setMessage(response?.message || "Size updated successfully");
      if (response?.success === false || response?.status === 422) {
        setBackendErrors(response?.error || {});
        return;
      }
      setTimeout(() => {
        navigate("/size");
      }, 1500);
    } catch (error) {
      console.error(error);
      setMessage(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  if (pageLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="container-fluid p-4">
      <div className="card p-4">
        
        {message && (
          <div
            className={`alert ${
              message.toLowerCase().includes("success")
                ? "alert-success"
                : "alert-danger"
            }`}
          >
            {message}
          </div>
        )}

        <SizeForm
          initialValues={size}
          onSubmit={handleSubmit}
          loading={loading}
          backendErrors={backendErrors}
          buttonText="Update Size"
        />
      </div>
    </div>
  );
}
